export default function SystemIdDetector(VcomProvider, jQuery) {
  const externalSystemId = VcomProvider.systemId;

  function getSystemId(target) {
    const el = jQuery(target.currentTarget);
    const isAdminSystemId = el.hasClass('admin-system-id');

    if (isAdminSystemId) {
      return Number(el.attr('system-id'));
    }
    return externalSystemId;
  }

  return {
    getSystemId,
  };
}
